import * as React from 'react'

export const SVG_Chevron = ({ className }: { className?: string }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33">
        <path
            fill="#4F5B68"
            fillRule="evenodd"
            d="M16.138 22.458a.834.834 0 0 0 .64-.318l8.033-10.21a.9.9 0 0 0-.123-1.234.833.833 0 0 0-1.194.126l-7.51 9.546-7.478-9.506a.833.833 0 0 0-1.194-.127.901.901 0 0 0-.123 1.234l8.032 10.21a.832.832 0 0 0 .917.28"
        />
    </svg>
)
